// Estimateur de charge de la HP (templates/components/capacity-estimator.twig).
// Le curseur est un <input type="range"> natif : on n'ajoute ici que la restitution des valeurs
// (tonnage, appareil, visuel, phrase de synthèse). Sans JavaScript, la valeur par défaut du
// gabarit reste affichée et cohérente.
const PERCENT = 100
const PROGRESS_DECIMALS = 2

const format = (value) => new Intl.NumberFormat('fr-FR').format(value)

const sync = (root) => {
  const input = root.querySelector('[data-capacity-input]')
  const threshold = Number(root.dataset.threshold)
  const value = Number(input.value)
  // `>=` et non `>` : la bascule se fait « à partir de » la valeur du seuil, celle-ci incluse.
  const isAbove = value >= threshold
  const name = isAbove ? root.dataset.aircraftAbove : root.dataset.aircraftBelow

  root.querySelector('[data-capacity-value]').textContent = format(value)
  root.querySelector('[data-capacity-aircraft]').textContent = name

  const note = root.querySelector('[data-capacity-note]')
  if (note) {
    // Une phrase complète par appareil : les deux désignations ne prennent pas le même
    // article (« L'AS350 », « Le H225 »), qu'un gabarit à préfixe figé rendrait faux.
    note.textContent = (isAbove ? root.dataset.noteAbove : root.dataset.noteBelow)
      .replace('%weight%', format(value))
  }

  for (const plane of root.querySelectorAll('[data-capacity-plane]')) {
    plane.classList.toggle('is-current', plane.dataset.capacityPlane === (isAbove ? 'above' : 'below'))
  }

  // progression du remplissage : consommée par le CSS du curseur
  const min = Number(input.min)
  const ratio = (value - min) / (Number(input.max) - min)
  root.style.setProperty('--capacity-progress', `${(ratio * PERCENT).toFixed(PROGRESS_DECIMALS)}%`)
}

document.addEventListener('DOMContentLoaded', () => {
  for (const root of document.querySelectorAll('[data-capacity-estimator]')) {
    const input = root.querySelector('[data-capacity-input]')
    if (!input) {
      continue
    }

    input.addEventListener('input', () => sync(root))
    sync(root)
  }
})
